module.exports = __webpack_public_path__ + "img/vip.7952a5c9.png";